import { PopupType } from '../../../components/popup/types';
import type { CoreStoreType } from '../../../store/CoreStore';
import { popupActions } from '../../../store/slices/popup/slice';
import type { GameCommunicationMessageType, IGameCommunicationProcessor } from '../types';

export interface CustomServerMessage extends GameCommunicationMessageType {
  value?: string;
}

export class GameCommunicationMessageProcessor implements IGameCommunicationProcessor {
  messageName = 'message';

  process(message: CustomServerMessage, store: CoreStoreType): void {
    if (message.value) {
      const data = JSON.parse(message.value)[0];

      store.dispatch(popupActions.setCustomPopup(data));
      store.dispatch(popupActions.pushPopup(PopupType.CustomPopup));
    }
  }
}
